<div class="w-auto h-auto">
    <div class="flex justify-between mb-0 h-5 ml-3 mt-3">
      <h5 class="text-base font-bold tracking-tight text-gray-900 truncate w-11/12" title="{{data?.data?.route_name}}">
        <span class="route-color mr-3" [ngStyle]="{'background-color': data?.data?.color || '#1abc9c'}"></span>{{data?.data?.route_name}}
      </h5>
    </div>
    <div class="flex my-1 px-3">
        <div class="text-base my-2" *ngIf="data?.type === 'ORIGIN'"><span class="font-semibold">{{'text.start_location' | translate}}: </span>{{data?.data?.start_location?.street}}, {{data?.data?.start_location?.name}}</div>
        <div class="text-base my-2" *ngIf="data?.type === 'DESTINATION'"><span class="font-semibold">{{'text.end_location' | translate}}: </span>{{data?.data?.end_location?.street}}, {{data?.data?.end_location?.name}}</div>
    </div>
</div>  